<sm-table class="compact col-12" [data]="table" [allowDelete]=false (onRowSelect)="rowSelect($event)" (onDelete)="deleteRow($event)"></sm-table>